export const Languages = ['en', 'vi'];

export const urlApiAuth = {
  login: 'auth/login',
  refreshToken: 'auth/refresh-token',
};

export const TIME_OUT = 10 * 1000;

export const PREPARATION_THRESHOLD = 3;
export const ROWS_PER_PAGE = 10;
export const STATUS_TABS: Array<string> = ['all', 'progress', 'hold', 'completed'];
export const DEFAULT_PAGE = 1;

export const BASE_COLORS = {
  BLUE_BOLD: '#005F73',
  RED: '#ED1002',
};

export const BREAK_POINTS = {
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export const DIALOG_MODE_CREATE = 'create';
export const DIALOG_MODE_EDIT = 'edit';
export const DIALOG_MODE_VIEW = 'view';
export const SEARCH_TIMEOUT = 500;
